import { Slide, toast } from "react-toastify";

export const notifySuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // theme: "light",
    transition: Slide,
    style: {
      background: "rgb(249, 188, 3)",  // ❗ red background
      color: "#000000ff",          // ❗ white text
      fontWeight: "bold",
      borderRadius: "10px",
    },
  });
};

export const notifyError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // theme: "light",
    transition: Slide,
    style: {
      background: "rgb(249, 188, 3)",  // ❗ red background
      color: "#000000ff",          // ❗ white text
      fontWeight: "bold",
      borderRadius: "10px",
    },
  });
};
export const notificationMsg = message => {
  toast.info(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light'
    
  })
}